<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.06349 16.7533C8.06349 17.6263 8.76984 18.3327 9.64286 18.3327C10.5159 18.3327 11.2222 17.6263 11.2222 16.7533H8.06349ZM15.1032 13.4279V8.80887C15.1032 6.22951 13.3175 4.07078 10.9048 3.49935V2.92792C10.9048 2.22951 10.3413 1.66602 9.64286 1.66602C8.94444 1.66602 8.38095 2.22951 8.38095 2.92792V3.49935C5.96825 4.07078 4.18254 6.22951 4.18254 8.80887V13.4279L2.5 15.1105V15.9517H16.7857V15.1105L15.1032 13.4279ZM12.8175 10.4041H10.4365V12.7851H8.84921V10.4041H6.46825V8.80887H8.84921V6.42792H10.4365V8.80887H12.8175V10.4041Z" :fill="iconColor"/>
    <path d="M12.8175 10.4041H10.4365V12.7851H8.84921V10.4041H6.46825V8.80887H8.84921V6.42792H10.4365V8.80887H12.8175V10.4041Z" :fill="iconColor"/>  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconAlert",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
